var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDoNotEat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38.8 31.4",
    style: {
      enableBackground: "new 0 0 38.8 31.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1313",
    transform: "translate(-0.482 -0.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3841",
    className: "st0",
    d: "M36.1,23.6c-1-0.7-2.4-0.5-3.3,0.4c-0.7-0.8-1.5-1.6-2.2-2.4c-0.8,1.5-1.1,2.5-2.4,3.3 c0.9,0.9,1,1,1.9,1.8c-0.8,0.9-0.9,2.2-0.2,3.2c0.6,0.8,1.6,1.2,2.6,1c1.2-0.3,2-1.5,1.9-2.7c1.7-0.2,2.5-0.8,2.8-1.9 C37.3,25.2,36.9,24.2,36.1,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3842",
    className: "st0",
    d: "M9.1,21.5c0,0-2.7,2.9-2.7,2.8c-0.9-0.8-2.2-0.9-3.2-0.3c-0.9,0.6-1.3,1.7-1,2.7 c0.3,1.2,1.1,1.7,2.8,1.9c-0.2,1.2,0.6,2.4,1.8,2.7c0.9,0.3,2,0,2.6-0.8c0.8-1,0.7-2.5-0.2-3.4c0.6-0.5,1.2-1.1,1.7-1.7 C9.7,24.7,9.6,23,9.1,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3843",
    className: "st0",
    d: "M32.8,9.5c0.9-1,1.4-1.4,2.3-2.4c0.8,0.8,2.1,1,3.1,0.3c0.9-0.5,1.3-1.6,1.1-2.6 c-0.3-1.3-1.5-2.1-2.8-2c0.2-1.3-0.6-2.4-1.9-2.7c-1-0.3-2,0.1-2.6,0.9c-0.8,1-0.7,2.5,0.2,3.4c-0.5,0.4-1.5,1.5-1.5,1.5l1.7,0.7 C32.8,7.5,32.9,8.5,32.8,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3844",
    className: "st0",
    d: "M7,9.6c-0.9-1-1.4-1.4-2.3-2.4C3.9,8,2.6,8.1,1.6,7.5C0.7,7,0.3,5.9,0.6,4.9 c0.3-1.3,1.5-2.1,2.8-2C3.2,1.7,4,0.5,5.2,0.2c1-0.3,2,0.1,2.6,0.9c0.8,1,0.7,2.5-0.2,3.4C8,4.9,9,5.9,9,5.9L7.3,6.6 C7,7.6,6.9,8.6,7,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3845",
    className: "st0",
    d: "M31.9,7.2c-1.4-0.7-3-1.2-4.6-1.3c-0.5-0.9-2.6-1.5-3.4-0.6c0,0-0.3,0.3-0.3,0.3 c-1.3-0.2-2.5-0.4-3.8-0.4c-1.2,0.1-2.5,0.2-3.7,0.5c-0.5-1.5-3.1-0.7-3.6,0.2C10.9,6,9.3,6.4,7.9,7.2c-0.7,1.9-0.5,4,0.4,5.8 c0.2,0.5,1.8,2.9,2.1-0.1c0-1.2,0.2-2.4,0.7-3.5c0.2-0.4,0.5-0.9,0.7-1.2c0.4-0.7,1.1-1.8,1.9-1.3c0.7,0.4-0.9,1.4-1.4,1.9 c-0.8,0.7-1.3,1.7-1.5,2.8c-0.1,0.8-0.2,2-0.4,2.9c-0.1,0.5-0.3,1-0.5,1.4c-0.4,0.8-0.3,3.3,0,3.5c0,0,0.6,5.9,3.8,5.8 c0.5,0,1.1-0.2,1.5-0.5c0,0.4,0,0.7,0,1.1c0,0.6,0.5,1,1.1,0.9c0,0,0.1,0,0.1,0c0.4,0,0.8-0.3,1-0.7c0.2,0.4,0.6,0.7,1.1,0.7 c0.5,0,0.9-0.3,1.1-0.7c0.2,0.4,0.6,0.7,1.1,0.7c0.5,0,0.9-0.3,1.1-0.7c0,0.1,0.1,0.1,0.1,0.1c0.3,0.4,0.8,0.6,1.3,0.5 c0.5-0.1,0.8-0.4,0.8-0.9c0-0.3,0-0.6,0-1v0c0.3,0.3,0.8,0.4,1.2,0.4c2.6,0,4.4-4.7,4.4-4.7c0.1-0.3,0.5-4,0.2-4.6 c-0.2-0.5-0.4-0.9-0.5-1.4c-0.2-0.8-0.3-2.1-0.4-2.9c-0.1-1.1-0.6-2.1-1.5-2.8C27.1,8.3,25.8,7.4,26,7l0,0c0-0.1,0.1-0.1,0.2-0.2 c0.8-0.5,1.5,0.6,1.9,1.3c0.2,0.3,0.4,0.7,0.6,1.1c0.2,0.3,0.3,0.6,0.4,0.8c0.3,0.9,0.4,1.9,0.4,2.8c0.2,3,1.8,0.5,2.1,0.1 c0.6-1.1,0.9-2.3,0.9-3.6C32.3,8.6,32.2,7.9,31.9,7.2z M15.4,16.7c-1.7,0.2-3.2-1.1-3.4-2.8s1.1-3.2,2.8-3.4 c1.7-0.2,3.2,1.1,3.4,2.8c0,0.1,0,0.2,0,0.3C18.3,15.2,17,16.6,15.4,16.7z M19.9,20c-1.1-0.1-2-0.9-2.3-2c0-0.7,1.2-1.3,2.2-1.2 s2.3,0.4,2.2,1.1C21.8,18.9,20.9,19.7,19.9,20L19.9,20z M27.2,13.7c-0.2,1.6-1.5,2.7-3.1,2.5c-1.6-0.2-2.7-1.5-2.5-3.1 c0.1-1.5,1.4-2.6,2.8-2.6C26,10.7,27.3,12.1,27.2,13.7L27.2,13.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoNotEat);
export default __webpack_public_path__ + "static/media/icon-do-not-eat.006cf75f2f794301a09ceda6421ca672.svg";
export { ForwardRef as ReactComponent };